export class ProfitControlHeadDto {
    profitControlHeadId?: number;
    profitControlHead?: string;
    plantId?:number;
    isActive: boolean;
    createdAt : Date ;
    createdUser : string;
    updatedAt : Date ;
    updatedUser : string;
    versionFlag : number;


    constructor   (
    profitControlHeadId?:number,
    profitControlHead?:string,
    plantId?:number,
    isActive?: boolean,
    createdAt ?: Date  ,
    createdUser? : string,
    updatedAt ?: Date  ,
    updatedUser ?:string,
    versionFlag ?: number
    ){
this.profitControlHeadId=profitControlHeadId;
this.profitControlHead=profitControlHead;
this.plantId=plantId;
this.createdUser = createdUser;
this.isActive = isActive;  
this.updatedUser = updatedUser;
this.versionFlag = versionFlag;
this.updatedAt=updatedAt;
this.createdAt=createdAt
    }
}